var $a0b4f895e1596b3b$exports = {};
!function(e) {
    "use strict";
    function n(e, n, t) {
        return t.a = e, t.f = n, t;
    }
    function F2(e) {
        return n(2, e, function(n) {
            return function(t) {
                return e(n, t);
            };
        });
    }
    function F3(e) {
        return n(3, e, function(n) {
            return function(t) {
                return function(r) {
                    return e(n, t, r);
                };
            };
        });
    }
    function F4(e) {
        return n(4, e, function(n) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return e(n, t, r, a);
                    };
                };
            };
        });
    }
    function F5(e) {
        return n(5, e, function(n) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return e(n, t, r, a, i);
                        };
                    };
                };
            };
        });
    }
    function F6(e) {
        return n(6, e, function(n) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(o) {
                                return e(n, t, r, a, i, o);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(e) {
        return n(7, e, function(n) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(o) {
                                return function(u) {
                                    return e(n, t, r, a, i, o, u);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(e, n, t) {
        return 2 === e.a ? e.f(n, t) : e(n)(t);
    }
    function A3(e, n, t, r) {
        return 3 === e.a ? e.f(n, t, r) : e(n)(t)(r);
    }
    function A4(e, n, t, r, a) {
        return 4 === e.a ? e.f(n, t, r, a) : e(n)(t)(r)(a);
    }
    function A5(e, n, t, r, a, i) {
        return 5 === e.a ? e.f(n, t, r, a, i) : e(n)(t)(r)(a)(i);
    }
    function A6(e, n, t, r, a, i, o) {
        return 6 === e.a ? e.f(n, t, r, a, i, o) : e(n)(t)(r)(a)(i)(o);
    }
    function A7(e, n, t, r, a, i, o, u) {
        return 7 === e.a ? e.f(n, t, r, a, i, o, u) : e(n)(t)(r)(a)(i)(o)(u);
    }
    function t(e, n) {
        for(var t, a = [], i = r(e, n, 0, a); i && (t = a.pop()); i = r(t.a, t.b, 0, a));
        return i;
    }
    function r(e, n, t, a) {
        if (e === n) return !0;
        if ("object" != typeof e || null === e || null === n) return "function" == typeof e && b(5), !1;
        if (t > 100) return a.push(o(e, n)), !0;
        for(var i in 0 > e.$ && (e = Xe(e), n = Xe(n)), e)if (!r(e[i], n[i], t + 1, a)) return !1;
        return !0;
    }
    function a(e, n, t) {
        if ("object" != typeof e) return e === n ? 0 : n > e ? -1 : 1;
        if (void 0 === e.$) return (t = a(e.a, n.a)) || (t = a(e.b, n.b)) ? t : a(e.c, n.c);
        for(; e.b && n.b && !(t = a(e.a, n.a)); e = e.b, n = n.b);
        return t || (e.b ? 1 : n.b ? -1 : 0);
    }
    var i = F2(function(e, n) {
        var t = a(e, n);
        return 0 > t ? He : t ? Ye : Ke;
    });
    function o(e, n) {
        return {
            a: e,
            b: n
        };
    }
    function u(e, n) {
        var t = {};
        for(var r in e)t[r] = e[r];
        for(var r in n)t[r] = n[r];
        return t;
    }
    function s(e, n) {
        if ("string" == typeof e) return e + n;
        if (!e.b) return n;
        var t = c(e.a, n);
        e = e.b;
        for(var r = t; e.b; e = e.b)r = r.b = c(e.a, n);
        return t;
    }
    var f = {
        $: 0
    };
    function c(e, n) {
        return {
            $: 1,
            a: e,
            b: n
        };
    }
    var h = F2(c);
    function l(e) {
        for(var n = f, t = e.length; t--;)n = c(e[t], n);
        return n;
    }
    var d = F2(function(e, n) {
        return l((function(e) {
            for(var n = []; e.b; e = e.b)n.push(e.a);
            return n;
        })(n).sort(function(n, t) {
            return a(e(n), e(t));
        }));
    }), v = F3(function(e, n, t) {
        for(var r = Array(e), a = 0; e > a; a++)r[a] = t(n + a);
        return r;
    }), g = F2(function(e, n) {
        for(var t = Array(e), r = 0; e > r && n.b; r++)t[r] = n.a, n = n.b;
        return t.length = r, o(t, n);
    });
    function b(e) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + e + ".md");
    }
    var m = F2(function(e, n) {
        var t = n % e;
        return 0 === e ? b(11) : t > 0 && 0 > e || 0 > t && e > 0 ? t + e : t;
    }), y = Math.ceil, p = Math.floor, w = Math.log, $ = F2(function(e, n) {
        return e + n;
    }), k = F2(function(e, n) {
        return n.split(e);
    }), I = F3(function(e, n, t) {
        return t.slice(e, n);
    }), T = F2(function(e, n) {
        return n.indexOf(e) > -1;
    }), A = F2(function(e, n) {
        return 0 === n.indexOf(e);
    }), j = F2(function(e, n) {
        var t = e.length;
        if (1 > t) return f;
        for(var r = 0, a = []; (r = n.indexOf(e, r)) > -1;)a.push(r), r += t;
        return l(a);
    });
    function x(e) {
        return {
            $: 2,
            b: e
        };
    }
    x(function(e) {
        return "number" != typeof e ? E("an INT", e) : e > -2147483647 && 2147483647 > e && (0 | e) === e ? nn(e) : !isFinite(e) || e % 1 ? E("an INT", e) : nn(e);
    }), x(function(e) {
        return "boolean" == typeof e ? nn(e) : E("a BOOL", e);
    }), x(function(e) {
        return "number" == typeof e ? nn(e) : E("a FLOAT", e);
    }), x(function(e) {
        return nn(e);
    }), x(function(e) {
        return "string" == typeof e ? nn(e) : e instanceof String ? nn(e + "") : E("a STRING", e);
    });
    var S = F2(function(e, n) {
        return B(e, n);
    });
    function B(e, n) {
        switch(e.$){
            case 2:
                return e.b(n);
            case 5:
                return null === n ? nn(e.c) : E("null", n);
            case 3:
                return C(n) ? N(e.b, n, l) : E("a LIST", n);
            case 4:
                return C(n) ? N(e.b, n, _) : E("an ARRAY", n);
            case 6:
                var t = e.d;
                if ("object" != typeof n || null === n || !(t in n)) return E("an OBJECT with a field named `" + t + "`", n);
                var r = B(e.b, n[t]);
                return Bn(r) ? r : Ze(A2(Ve, t, r.a));
            case 7:
                var a = e.e;
                return C(n) ? n.length > a ? (r = B(e.b, n[a]), Bn(r) ? r : Ze(A2(en, a, r.a))) : E("a LONGER array. Need index " + a + " but only see " + n.length + " entries", n) : E("an ARRAY", n);
            case 8:
                if ("object" != typeof n || null === n || C(n)) return E("an OBJECT", n);
                var i = f;
                for(var u in n)if (n.hasOwnProperty(u)) {
                    if (r = B(e.b, n[u]), !Bn(r)) return Ze(A2(Ve, u, r.a));
                    i = c(o(u, r.a), i);
                }
                return nn(fn(i));
            case 9:
                for(var s = e.f, h = e.g, d = 0; h.length > d; d++){
                    if (r = B(h[d], n), !Bn(r)) return r;
                    s = s(r.a);
                }
                return nn(s);
            case 10:
                return r = B(e.b, n), Bn(r) ? B(e.h(r.a), n) : r;
            case 11:
                for(var v = f, g = e.g; g.b; g = g.b){
                    if (r = B(g.a, n), Bn(r)) return r;
                    v = c(r.a, v);
                }
                return Ze(tn(fn(v)));
            case 1:
                return Ze(A2(Qe, e.a, n));
            case 0:
                return nn(e.a);
        }
    }
    function N(e, n, t) {
        for(var r = n.length, a = Array(r), i = 0; r > i; i++){
            var o = B(e, n[i]);
            if (!Bn(o)) return Ze(A2(en, i, o.a));
            a[i] = o.a;
        }
        return nn(t(a));
    }
    function C(e) {
        return Array.isArray(e) || "undefined" != typeof FileList && e instanceof FileList;
    }
    function _(e) {
        return A2(Sn, e.length, function(n) {
            return e[n];
        });
    }
    function E(e, n) {
        return Ze(A2(Qe, "Expecting " + e, n));
    }
    function F(e, n) {
        if (e === n) return !0;
        if (e.$ !== n.$) return !1;
        switch(e.$){
            case 0:
            case 1:
                return e.a === n.a;
            case 2:
                return e.b === n.b;
            case 5:
                return e.c === n.c;
            case 3:
            case 4:
            case 8:
                return F(e.b, n.b);
            case 6:
                return e.d === n.d && F(e.b, n.b);
            case 7:
                return e.e === n.e && F(e.b, n.b);
            case 9:
                return e.f === n.f && L(e.g, n.g);
            case 10:
                return e.h === n.h && F(e.b, n.b);
            case 11:
                return L(e.g, n.g);
        }
    }
    function L(e, n) {
        var t = e.length;
        if (t !== n.length) return !1;
        for(var r = 0; t > r; r++)if (!F(e[r], n[r])) return !1;
        return !0;
    }
    function q(e) {
        return e;
    }
    function O(e) {
        return {
            $: 0,
            a: e
        };
    }
    function P(e) {
        return {
            $: 2,
            b: e,
            c: null
        };
    }
    var W = F2(function(e, n) {
        return {
            $: 3,
            b: e,
            d: n
        };
    }), z = 0;
    function D(e) {
        var n = {
            $: 0,
            e: z++,
            f: e,
            g: null,
            h: []
        };
        return K(n), n;
    }
    function J(e, n) {
        e.h.push(n), K(e);
    }
    var M = !1, R = [];
    function K(e) {
        if (R.push(e), !M) {
            for(M = !0; e = R.shift();)Y(e);
            M = !1;
        }
    }
    function Y(e) {
        for(; e.f;){
            var n = e.f.$;
            if (0 === n || 1 === n) {
                for(; e.g && e.g.$ !== n;)e.g = e.g.i;
                if (!e.g) return;
                e.f = e.g.b(e.f.a), e.g = e.g.i;
            } else {
                if (2 === n) return void (e.f.c = e.f.b(function(n) {
                    e.f = n, K(e);
                }));
                if (5 === n) {
                    if (0 === e.h.length) return;
                    e.f = e.f.b(e.h.shift());
                } else e.g = {
                    $: 3 === n ? 0 : 1,
                    b: e.f.b,
                    i: e.g
                }, e.f = e.f.d;
            }
        }
    }
    var H = {};
    function G(e, n) {
        var t = {
            g: n,
            h: void 0
        }, r = e.c, a = e.d, i = e.e, o = e.f;
        function u(e) {
            return A2(W, u, {
                $: 5,
                b: function(n) {
                    var u = n.a;
                    return 0 === n.$ ? A3(a, t, u, e) : i && o ? A4(r, t, u.i, u.j, e) : A3(r, t, i ? u.i : u.j, e);
                }
            });
        }
        return t.h = D(A2(W, u, e.b));
    }
    var U = F2(function(e, n) {
        return P(function(t) {
            e.g(n), t(O(0));
        });
    });
    function X(e) {
        return function(n) {
            return {
                $: 1,
                k: e,
                l: n
            };
        };
    }
    function Z(e) {
        return {
            $: 2,
            m: e
        };
    }
    var Q = [], V = !1;
    function ee(e, n, t) {
        if (Q.push({
            p: e,
            q: n,
            r: t
        }), !V) {
            V = !0;
            for(var r; r = Q.shift();)ne(r.p, r.q, r.r);
            V = !1;
        }
    }
    function ne(e, n, t) {
        var r = {};
        for(var a in te(!0, n, r, null), te(!1, t, r, null), e)J(e[a], {
            $: "fx",
            a: r[a] || {
                i: f,
                j: f
            }
        });
    }
    function te(e, n, t, r) {
        switch(n.$){
            case 1:
                var a = n.k, i = function(e, n, t, r) {
                    function a(e) {
                        for(var n = t; n; n = n.t)e = n.s(e);
                        return e;
                    }
                    return A2(e ? H[n].e : H[n].f, a, r);
                }(e, a, r, n.l);
                return void (t[a] = function(e, n, t) {
                    return t = t || {
                        i: f,
                        j: f
                    }, e ? t.i = c(n, t.i) : t.j = c(n, t.j), t;
                }(e, i, t[a]));
            case 2:
                for(var o = n.m; o.b; o = o.b)te(e, o.a, t, r);
                return;
            case 3:
                return void te(e, n.o, t, {
                    s: n.n,
                    t: r
                });
        }
    }
    function re(e, n) {
        return function(e) {
            H[e] && b(3);
        }(e), H[e] = {
            e: ie,
            u: n,
            a: oe
        }, X(e);
    }
    var ae, ie = F2(function(e, n) {
        return n;
    });
    function oe(e) {
        var n = [], t = H[e].u, r = P(function(e) {
            var n = setTimeout(function() {
                e(O(0));
            }, 0);
            return function() {
                clearTimeout(n);
            };
        });
        return H[e].b = r, H[e].c = F3(function(e, a) {
            for(; a.b; a = a.b)for(var i = n, o = q(t(a.a)), u = 0; i.length > u; u++)i[u](o);
            return r;
        }), {
            subscribe: function(e) {
                n.push(e);
            },
            unsubscribe: function(e) {
                var t = (n = n.slice()).indexOf(e);
                0 > t || n.splice(t, 1);
            }
        };
    }
    var ue = "undefined" != typeof document ? document : {};
    function se(e, n) {
        e.appendChild(n);
    }
    function fe(e) {
        return {
            $: 0,
            a: e
        };
    }
    var ce = F2(function(e, n) {
        return F2(function(t, r) {
            for(var a = [], i = 0; r.b; r = r.b){
                var o = r.a;
                i += o.b || 0, a.push(o);
            }
            return i += a.length, {
                $: 1,
                c: n,
                d: ge(t),
                e: a,
                f: e,
                b: i
            };
        });
    })(void 0);
    F2(function(e, n) {
        return F2(function(t, r) {
            for(var a = [], i = 0; r.b; r = r.b){
                var o = r.a;
                i += o.b.b || 0, a.push(o);
            }
            return i += a.length, {
                $: 2,
                c: n,
                d: ge(t),
                e: a,
                f: e,
                b: i
            };
        });
    })(void 0);
    var he, le = F2(function(e, n) {
        return {
            $: "a2",
            n: e,
            o: n
        };
    }), de = F2(function(e, n) {
        return {
            $: "a3",
            n: e,
            o: n
        };
    }), ve = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
    function ge(e) {
        for(var n = {}; e.b; e = e.b){
            var t = e.a, r = t.$, a = t.n, i = t.o;
            if ("a2" !== r) {
                var o = n[r] || (n[r] = {});
                "a3" === r && "class" === a ? be(o, a, i) : o[a] = i;
            } else "className" === a ? be(n, a, q(i)) : n[a] = q(i);
        }
        return n;
    }
    function be(e, n, t) {
        var r = e[n];
        e[n] = r ? r + " " + t : t;
    }
    function me(e, n) {
        var t = e.$;
        if (5 === t) return me(e.k || (e.k = e.m()), n);
        if (0 === t) return ue.createTextNode(e.a);
        if (4 === t) {
            for(var r = e.k, a = e.j; 4 === r.$;)"object" != typeof a ? a = [
                a,
                r.j
            ] : a.push(r.j), r = r.k;
            var i = {
                j: a,
                p: n
            };
            return (o = me(r, i)).elm_event_node_ref = i, o;
        }
        if (3 === t) return ye(o = e.h(e.g), n, e.d), o;
        var o = e.f ? ue.createElementNS(e.f, e.c) : ue.createElement(e.c);
        ae && "a" == e.c && o.addEventListener("click", ae(o)), ye(o, n, e.d);
        for(var u = e.e, s = 0; u.length > s; s++)se(o, me(1 === t ? u[s] : u[s].b, n));
        return o;
    }
    function ye(e, n, t) {
        for(var r in t){
            var a = t[r];
            "a1" === r ? pe(e, a) : "a0" === r ? ke(e, n, a) : "a3" === r ? we(e, a) : "a4" === r ? $e(e, a) : ("value" !== r && "checked" !== r || e[r] !== a) && (e[r] = a);
        }
    }
    function pe(e, n) {
        var t = e.style;
        for(var r in n)t[r] = n[r];
    }
    function we(e, n) {
        for(var t in n){
            var r = n[t];
            void 0 !== r ? e.setAttribute(t, r) : e.removeAttribute(t);
        }
    }
    function $e(e, n) {
        for(var t in n){
            var r = n[t], a = r.f, i = r.o;
            void 0 !== i ? e.setAttributeNS(a, t, i) : e.removeAttributeNS(a, t);
        }
    }
    function ke(e, n, t) {
        var r = e.elmFs || (e.elmFs = {});
        for(var a in t){
            var i = t[a], o = r[a];
            if (i) {
                if (o) {
                    if (o.q.$ === i.$) {
                        o.q = i;
                        continue;
                    }
                    e.removeEventListener(a, o);
                }
                o = Ie(n, i), e.addEventListener(a, o, he && {
                    passive: 2 > Nn(i)
                }), r[a] = o;
            } else e.removeEventListener(a, o), r[a] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                he = !0;
            }
        }));
    } catch (e) {}
    function Ie(e, n) {
        function t(n) {
            var r = t.q, a = B(r.a, n);
            if (Bn(a)) {
                for(var i, o = Nn(r), u = a.a, s = o ? 3 > o ? u.a : u.s : u, f = 1 == o ? u.b : 3 == o && u.R, c = (f && n.stopPropagation(), (2 == o ? u.b : 3 == o && u.O) && n.preventDefault(), e); i = c.j;){
                    if ("function" == typeof i) s = i(s);
                    else for(var h = i.length; h--;)s = i[h](s);
                    c = c.p;
                }
                c(s, f);
            }
        }
        return t.q = n, t;
    }
    function Te(e, n) {
        return e.$ == n.$ && F(e.a, n.a);
    }
    function Ae(e, n, t, r) {
        var a = {
            $: n,
            r: t,
            s: r,
            t: void 0,
            u: void 0
        };
        return e.push(a), a;
    }
    function je(e, n, t, r) {
        if (e !== n) {
            var a = e.$, i = n.$;
            if (a !== i) {
                if (1 !== a || 2 !== i) return void Ae(t, 0, r, n);
                n = function(e) {
                    for(var n = e.e, t = n.length, r = Array(t), a = 0; t > a; a++)r[a] = n[a].b;
                    return {
                        $: 1,
                        c: e.c,
                        d: e.d,
                        e: r,
                        f: e.f,
                        b: e.b
                    };
                }(n), i = 1;
            }
            switch(i){
                case 5:
                    for(var o = e.l, u = n.l, s = o.length, f = s === u.length; f && s--;)f = o[s] === u[s];
                    if (f) return void (n.k = e.k);
                    n.k = n.m();
                    var c = [];
                    return je(e.k, n.k, c, 0), void (c.length > 0 && Ae(t, 1, r, c));
                case 4:
                    for(var h = e.j, l = n.j, d = !1, v = e.k; 4 === v.$;)d = !0, "object" != typeof h ? h = [
                        h,
                        v.j
                    ] : h.push(v.j), v = v.k;
                    for(var g = n.k; 4 === g.$;)d = !0, "object" != typeof l ? l = [
                        l,
                        g.j
                    ] : l.push(g.j), g = g.k;
                    return d && h.length !== l.length ? void Ae(t, 0, r, n) : ((d ? function(e, n) {
                        for(var t = 0; e.length > t; t++)if (e[t] !== n[t]) return !1;
                        return !0;
                    }(h, l) : h === l) || Ae(t, 2, r, l), void je(v, g, t, r + 1));
                case 0:
                    return void (e.a !== n.a && Ae(t, 3, r, n.a));
                case 1:
                    return void xe(e, n, t, r, Be);
                case 2:
                    return void xe(e, n, t, r, Ne);
                case 3:
                    if (e.h !== n.h) return void Ae(t, 0, r, n);
                    var b = Se(e.d, n.d);
                    b && Ae(t, 4, r, b);
                    var m = n.i(e.g, n.g);
                    return void (m && Ae(t, 5, r, m));
            }
        }
    }
    function xe(e, n, t, r, a) {
        if (e.c === n.c && e.f === n.f) {
            var i = Se(e.d, n.d);
            i && Ae(t, 4, r, i), a(e, n, t, r);
        } else Ae(t, 0, r, n);
    }
    function Se(e, n, t) {
        var r;
        for(var a in e)if ("a1" !== a && "a0" !== a && "a3" !== a && "a4" !== a) {
            if (a in n) {
                var i = e[a], o = n[a];
                i === o && "value" !== a && "checked" !== a || "a0" === t && Te(i, o) || ((r = r || {})[a] = o);
            } else (r = r || {})[a] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: e[a].f,
                o: void 0
            } : "string" == typeof e[a] ? "" : null;
        } else {
            var u = Se(e[a], n[a] || {}, a);
            u && ((r = r || {})[a] = u);
        }
        for(var s in n)s in e || ((r = r || {})[s] = n[s]);
        return r;
    }
    function Be(e, n, t, r) {
        var a = e.e, i = n.e, o = a.length, u = i.length;
        o > u ? Ae(t, 6, r, {
            v: u,
            i: o - u
        }) : u > o && Ae(t, 7, r, {
            v: o,
            e: i
        });
        for(var s = u > o ? o : u, f = 0; s > f; f++){
            var c = a[f];
            je(c, i[f], t, ++r), r += c.b || 0;
        }
    }
    function Ne(e, n, t, r) {
        for(var a = [], i = {}, o = [], u = e.e, s = n.e, f = u.length, c = s.length, h = 0, l = 0, d = r; f > h && c > l;){
            var v = (j = u[h]).a, g = (x = s[l]).a, b = j.b, m = x.b, y = void 0, p = void 0;
            if (v !== g) {
                var w = u[h + 1], $ = s[l + 1];
                if (w) {
                    var k = w.a, I = w.b;
                    p = g === k;
                }
                if ($) {
                    var T = $.a, A = $.b;
                    y = v === T;
                }
                if (y && p) je(b, A, a, ++d), _e(i, a, v, m, l, o), d += b.b || 0, Ee(i, a, v, I, ++d), d += I.b || 0, h += 2, l += 2;
                else if (y) d++, _e(i, a, g, m, l, o), je(b, A, a, d), d += b.b || 0, h += 1, l += 2;
                else if (p) Ee(i, a, v, b, ++d), d += b.b || 0, je(I, m, a, ++d), d += I.b || 0, h += 2, l += 1;
                else {
                    if (!w || k !== T) break;
                    Ee(i, a, v, b, ++d), _e(i, a, g, m, l, o), d += b.b || 0, je(I, A, a, ++d), d += I.b || 0, h += 2, l += 2;
                }
            } else je(b, m, a, ++d), d += b.b || 0, h++, l++;
        }
        for(; f > h;){
            var j;
            d++, Ee(i, a, (j = u[h]).a, b = j.b, d), d += b.b || 0, h++;
        }
        for(; c > l;){
            var x, S = S || [];
            _e(i, a, (x = s[l]).a, x.b, void 0, S), l++;
        }
        (a.length > 0 || o.length > 0 || S) && Ae(t, 8, r, {
            w: a,
            x: o,
            y: S
        });
    }
    var Ce = "_elmW6BL";
    function _e(e, n, t, r, a, i) {
        var o = e[t];
        if (!o) return i.push({
            r: a,
            A: o = {
                c: 0,
                z: r,
                r: a,
                s: void 0
            }
        }), void (e[t] = o);
        if (1 === o.c) {
            i.push({
                r: a,
                A: o
            }), o.c = 2;
            var u = [];
            return je(o.z, r, u, o.r), o.r = a, void (o.s.s = {
                w: u,
                A: o
            });
        }
        _e(e, n, t + Ce, r, a, i);
    }
    function Ee(e, n, t, r, a) {
        var i = e[t];
        if (i) {
            if (0 === i.c) {
                i.c = 2;
                var o = [];
                return je(r, i.z, o, a), void Ae(n, 9, a, {
                    w: o,
                    A: i
                });
            }
            Ee(e, n, t + Ce, r, a);
        } else {
            var u = Ae(n, 9, a, void 0);
            e[t] = {
                c: 1,
                z: r,
                r: a,
                s: u
            };
        }
    }
    function Fe(e, n, t, r) {
        Le(e, n, t, 0, 0, n.b, r);
    }
    function Le(e, n, t, r, a, i, o) {
        for(var u = t[r], s = u.r; s === a;){
            var f = u.$;
            if (1 === f) Fe(e, n.k, u.s, o);
            else if (8 === f) u.t = e, u.u = o, (c = u.s.w).length > 0 && Le(e, n, c, 0, a, i, o);
            else if (9 === f) {
                u.t = e, u.u = o;
                var c, h = u.s;
                h && (h.A.s = e, (c = h.w).length > 0 && Le(e, n, c, 0, a, i, o));
            } else u.t = e, u.u = o;
            if (!(u = t[++r]) || (s = u.r) > i) return r;
        }
        var l = n.$;
        if (4 === l) {
            for(var d = n.k; 4 === d.$;)d = d.k;
            return Le(e, d, t, r, a + 1, i, e.elm_event_node_ref);
        }
        for(var v = n.e, g = e.childNodes, b = 0; v.length > b; b++){
            a++;
            var m = 1 === l ? v[b] : v[b].b, y = a + (m.b || 0);
            if (!(a > s || s > y || (u = t[r = Le(g[b], m, t, r, a, y, o)]) && (s = u.r) <= i)) return r;
            a = y;
        }
        return r;
    }
    function qe(e, n) {
        for(var t = 0; n.length > t; t++){
            var r = n[t], a = r.t, i = Oe(a, r);
            a === e && (e = i);
        }
        return e;
    }
    function Oe(e, n) {
        switch(n.$){
            case 0:
                return function(e, n, t) {
                    var r = e.parentNode, a = me(n, t);
                    return a.elm_event_node_ref || (a.elm_event_node_ref = e.elm_event_node_ref), r && a !== e && r.replaceChild(a, e), a;
                }(e, n.s, n.u);
            case 4:
                return ye(e, n.u, n.s), e;
            case 3:
                return e.replaceData(0, e.length, n.s), e;
            case 1:
                return qe(e, n.s);
            case 2:
                return e.elm_event_node_ref ? e.elm_event_node_ref.j = n.s : e.elm_event_node_ref = {
                    j: n.s,
                    p: n.u
                }, e;
            case 6:
                for(var t = n.s, r = 0; t.i > r; r++)e.removeChild(e.childNodes[t.v]);
                return e;
            case 7:
                for(var a = (t = n.s).e, i = e.childNodes[r = t.v]; a.length > r; r++)e.insertBefore(me(a[r], n.u), i);
                return e;
            case 9:
                if (!(t = n.s)) return e.parentNode.removeChild(e), e;
                var o = t.A;
                return void 0 !== o.r && e.parentNode.removeChild(e), o.s = qe(e, t.w), e;
            case 8:
                return function(e, n) {
                    var t = n.s, r = function(e, n) {
                        if (e) {
                            for(var t = ue.createDocumentFragment(), r = 0; e.length > r; r++){
                                var a = e[r].A;
                                se(t, 2 === a.c ? a.s : me(a.z, n.u));
                            }
                            return t;
                        }
                    }(t.y, n);
                    e = qe(e, t.w);
                    for(var a = t.x, i = 0; a.length > i; i++){
                        var o = a[i], u = o.A, s = 2 === u.c ? u.s : me(u.z, n.u);
                        e.insertBefore(s, e.childNodes[o.r]);
                    }
                    return r && se(e, r), e;
                }(e, n);
            case 5:
                return n.s(e);
            default:
                b(10);
        }
    }
    function Pe(e) {
        if (3 === e.nodeType) return fe(e.textContent);
        if (1 !== e.nodeType) return fe("");
        for(var n = f, t = e.attributes, r = t.length; r--;){
            var a = t[r];
            n = c(A2(de, a.name, a.value), n);
        }
        var i = e.tagName.toLowerCase(), o = f, u = e.childNodes;
        for(r = u.length; r--;)o = c(Pe(u[r]), o);
        return A3(ce, i, n, o);
    }
    var We = F4(function(e, n, t, r) {
        return function(e, n, t, r, a, i) {
            var o = A2(S, e, n ? n.flags : void 0);
            Bn(o) || b(2);
            var u = {}, s = t(o.a), f = s.a, c = i(l, f), h = function(e, n) {
                var t;
                for(var r in H){
                    var a = H[r];
                    a.a && ((t = t || {})[r] = a.a(r, n)), e[r] = G(a, n);
                }
                return t;
            }(u, l);
            function l(e, n) {
                var t = A2(r, e, f);
                c(f = t.a, n), ee(u, t.b, a(f));
            }
            return ee(u, s.b, a(f)), h ? {
                ports: h
            } : {};
        }(n, r, e.aP, e.aY, e.aX, function(n, t) {
            var r = e.P && e.P(n), a = e.a_, i = ue.title, o = ue.body, u = Pe(o);
            return function(e, n) {
                n(e);
                var t = 0;
                function r() {
                    t = 1 === t ? 0 : (ze(r), n(e), 1);
                }
                return function(a, i) {
                    e = a, i ? (n(e), 2 === t && (t = 1)) : (0 === t && ze(r), t = 2);
                };
            }(t, function(e) {
                ae = r;
                var t = a(e), s = ce("body")(f)(t.aH), c = function(e, n) {
                    var t = [];
                    return je(e, n, t, 0), t;
                }(u, s);
                o = function(e, n, t, r) {
                    return 0 === t.length ? e : (Fe(e, n, t, r), qe(e, t));
                }(o, u, c, n), u = s, ae = 0, i !== t.J && (ue.title = i = t.J);
            });
        });
    }), ze = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(e) {
        return setTimeout(e, 1e3 / 60);
    });
    function De() {
        return Rn(ue.location.href).a || b(1);
    }
    var Je = F2(function(e, n) {
        return A2(ct, Kn, P(function() {
            history.pushState({}, "", n), e();
        }));
    }), Me = ("undefined" != typeof document && document, "undefined" != typeof window ? window : {
        addEventListener: function() {},
        removeEventListener: function() {}
    }), Re = F2(function(e) {
        return e;
    }), Ke = 1, Ye = 2, He = 0, Ge = h, Ue = F3(function(e, n, t) {
        for(;;){
            if (-2 === t.$) return n;
            var r = t.d, a = e, i = A3(e, t.b, t.c, A3(Ue, e, n, t.e));
            e = a, n = i, t = r;
        }
    }), Xe = function(e) {
        return A3(Ue, F3(function(e, n, t) {
            return A2(Ge, o(e, n), t);
        }), f, e);
    }, Ze = function(e) {
        return {
            $: 1,
            a: e
        };
    }, Qe = F2(function(e, n) {
        return {
            $: 3,
            a: e,
            b: n
        };
    }), Ve = F2(function(e, n) {
        return {
            $: 0,
            a: e,
            b: n
        };
    }), en = F2(function(e, n) {
        return {
            $: 1,
            a: e,
            b: n
        };
    }), nn = function(e) {
        return {
            $: 0,
            a: e
        };
    }, tn = function(e) {
        return {
            $: 2,
            a: e
        };
    }, rn = function(e) {
        return {
            $: 0,
            a: e
        };
    }, an = {
        $: 1
    }, on = function(e) {
        return e + "";
    }, un = F2(function(e, n) {
        return l(A2(k, e, n));
    }), sn = F3(function(e, n, t) {
        for(;;){
            if (!t.b) return n;
            var r = t.b, a = e, i = A2(e, t.a, n);
            e = a, n = i, t = r;
        }
    }), fn = function(e) {
        return A3(sn, Ge, f, e);
    }, cn = 32, hn = F4(function(e, n, t, r) {
        return {
            $: 0,
            a: e,
            b: n,
            c: t,
            d: r
        };
    }), ln = [], dn = y, vn = F2(function(e, n) {
        return w(n) / w(e);
    }), gn = dn(A2(vn, 2, cn)), bn = A4(hn, 0, gn, ln, ln), mn = v, yn = function(e) {
        return {
            $: 1,
            a: e
        };
    }, pn = p, wn = function(e) {
        return e.length;
    }, $n = F2(function(e, n) {
        return a(e, n) > 0 ? e : n;
    }), kn = function(e) {
        return {
            $: 0,
            a: e
        };
    }, In = g, Tn = F2(function(e, n) {
        for(;;){
            var t = A2(In, cn, e), r = t.b, a = A2(Ge, kn(t.a), n);
            if (!r.b) return fn(a);
            e = r, n = a;
        }
    }), An = F2(function(e, n) {
        for(;;){
            var t = dn(n / cn);
            if (1 === t) return A2(In, cn, e).a;
            e = A2(Tn, e, f), n = t;
        }
    }), jn = F2(function(e, n) {
        if (n.e) {
            var t = n.e * cn, r = pn(A2(vn, cn, t - 1)), a = e ? fn(n.h) : n.h, i = A2(An, a, n.e);
            return A4(hn, wn(n.g) + t, A2($n, 5, r * gn), i, n.g);
        }
        return A4(hn, wn(n.g), gn, ln, n.g);
    }), xn = F5(function(e, n, t, r, a) {
        for(;;){
            if (0 > n) return A2(jn, !1, {
                h: r,
                e: t / cn | 0,
                g: a
            });
            var i = yn(A3(mn, cn, n, e));
            n -= cn, r = A2(Ge, i, r);
        }
    }), Sn = F2(function(e, n) {
        if (e > 0) {
            var t = e % cn;
            return A5(xn, n, e - t - cn, e, f, A3(mn, t, e - t, n));
        }
        return bn;
    }), Bn = function(e) {
        return !e.$;
    }, Nn = function(e) {
        switch(e.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, Cn = function(e) {
        return e;
    }, _n = F6(function(e, n, t, r, a, i) {
        return {
            aa: i,
            ad: n,
            aj: r,
            al: t,
            ap: e,
            aq: a
        };
    }), En = T, Fn = I, Ln = F2(function(e, n) {
        return 1 > e ? n : A3(Fn, e, n.length, n);
    }), qn = j, On = function(e) {
        return "" === e;
    }, Pn = F2(function(e, n) {
        return 1 > e ? "" : A3(Fn, 0, e, n);
    }), Wn = F5(function(e, n, t, r, a) {
        if (On(a) || A2(En, "@", a)) return an;
        var i = A2(qn, ":", a);
        if (i.b) {
            if (i.b.b) return an;
            var o = i.a, u = function(e) {
                for(var n = 0, t = e.charCodeAt(0), r = 43 == t || 45 == t ? 1 : 0, a = r; e.length > a; ++a){
                    var i = e.charCodeAt(a);
                    if (48 > i || i > 57) return an;
                    n = 10 * n + i - 48;
                }
                return a == r ? an : rn(45 == t ? -n : n);
            }(A2(Ln, o + 1, a));
            if (1 === u.$) return an;
            var s = u;
            return rn(A6(_n, e, A2(Pn, o, a), s, n, t, r));
        }
        return rn(A6(_n, e, a, an, n, t, r));
    }), zn = F4(function(e, n, t, r) {
        if (On(r)) return an;
        var a = A2(qn, "/", r);
        if (a.b) {
            var i = a.a;
            return A5(Wn, e, A2(Ln, i, r), n, t, A2(Pn, i, r));
        }
        return A5(Wn, e, "/", n, t, r);
    }), Dn = F3(function(e, n, t) {
        if (On(t)) return an;
        var r = A2(qn, "?", t);
        if (r.b) {
            var a = r.a;
            return A4(zn, e, rn(A2(Ln, a + 1, t)), n, A2(Pn, a, t));
        }
        return A4(zn, e, an, n, t);
    }), Jn = F2(function(e, n) {
        if (On(n)) return an;
        var t = A2(qn, "#", n);
        if (t.b) {
            var r = t.a;
            return A3(Dn, e, rn(A2(Ln, r + 1, n)), A2(Pn, r, n));
        }
        return A3(Dn, e, an, n);
    }), Mn = A, Rn = function(e) {
        return A2(Mn, "http://", e) ? A2(Jn, 0, A2(Ln, 7, e)) : A2(Mn, "https://", e) ? A2(Jn, 1, A2(Ln, 8, e)) : an;
    }, Kn = function() {
        for(;;);
    }, Yn = O, Hn = Yn(0), Gn = F4(function(e, n, t, r) {
        if (r.b) {
            var a = r.a, i = r.b;
            if (i.b) {
                var o = i.a, u = i.b;
                if (u.b) {
                    var s = u.a, f = u.b;
                    if (f.b) {
                        var c = f.b;
                        return A2(e, a, A2(e, o, A2(e, s, A2(e, f.a, t > 500 ? A3(sn, e, n, fn(c)) : A4(Gn, e, n, t + 1, c)))));
                    }
                    return A2(e, a, A2(e, o, A2(e, s, n)));
                }
                return A2(e, a, A2(e, o, n));
            }
            return A2(e, a, n);
        }
        return n;
    }), Un = F3(function(e, n, t) {
        return A4(Gn, e, n, 0, t);
    }), Xn = F2(function(e, n) {
        return A3(Un, F2(function(n, t) {
            return A2(Ge, e(n), t);
        }), f, n);
    }), Zn = W, Qn = F2(function(e, n) {
        return A2(Zn, function(n) {
            return Yn(e(n));
        }, n);
    }), Vn = F3(function(e, n, t) {
        return A2(Zn, function(n) {
            return A2(Zn, function(t) {
                return Yn(A2(e, n, t));
            }, t);
        }, n);
    }), et = U, nt = F2(function(e, n) {
        var t = n;
        return function(e) {
            return P(function(n) {
                n(O(D(e)));
            });
        }(A2(Zn, et(e), t));
    });
    H.Task = {
        b: Hn,
        c: F3(function(e, n) {
            var t;
            return A2(Qn, function() {
                return 0;
            }, (t = A2(Xn, nt(e), n), A3(Un, Vn(Ge), Yn(f), t)));
        }),
        d: F3(function() {
            return Yn(0);
        }),
        e: F2(function(e, n) {
            return A2(Qn, e, n);
        }),
        f: void 0
    };
    var tt, rt, at, it, ot, ut, st, ft = X("Task"), ct = F2(function(e, n) {
        return ft(A2(Qn, e, n));
    }), ht = {
        $: 0
    }, lt = Je, dt = F2(function(e, n) {
        return 1 === e.$ ? n : n + ":" + on(e.a);
    }), vt = F3(function(e, n, t) {
        return 1 === n.$ ? t : s(t, s(e, n.a));
    }), gt = function(e) {
        return A3(vt, "#", e.aa, A3(vt, "?", e.aq, s(A2(dt, e.al, s(e.ap ? "https://" : "http://", e.ad)), e.aj)));
    }, bt = F3(function(e, n, t) {
        return o({
            L: t,
            w: ht
        }, A2(lt, t, gt(n)));
    }), mt = Z(f), yt = Z, pt = m, wt = function(e) {
        var n = e / 1e4 | 0, t = A2(pt, 100, e / 100 | 0), r = function() {
            switch(t){
                case 1:
                    return "January";
                case 2:
                    return "February";
                case 3:
                    return "March";
                case 4:
                    return "April";
                case 5:
                    return "May";
                case 6:
                    return "June";
                case 7:
                    return "July";
                case 8:
                    return "August";
                case 9:
                    return "September";
                case 10:
                    return "October";
                case 11:
                    return "November";
                case 12:
                    return "December";
                default:
                    return "Unknown";
            }
        }();
        return on(A2(pt, 100, e)) + " " + r + " " + on(n);
    }, $t = F2(function(e, n) {
        return A3(Un, F2(function(n, t) {
            return e(n) ? A2(Ge, n, t) : t;
        }), f, n);
    }), kt = F4(function(e, n, t, r) {
        return {
            aW: r,
            J: e,
            aZ: n,
            K: t
        };
    }), It = l([
        A4(kt, "Anchor", "anchor", 20240604, l([
            l([
                "Adrift on the ocean, unable to steer,",
                "unable to navigate, no one else here."
            ]),
            l([
                "This feeling of being lost is wearing me down,",
                "constantly worried that one day I may drown."
            ]),
            l([
                "Today, the sky is clear and the water, though vast,",
                "is calm and serene. But, how long will it last?"
            ]),
            l([
                "The wind picks up, and the turbulence grows,",
                "I try to ride the ebbs and flows."
            ]),
            l([
                "The quiet, dark depths, I hear them calling.",
                "So peaceful, so tranquil, just let go, just fall in."
            ]),
            l([
                "It's not real though, I say, don't listen, don't befriend.",
                "That peace is a lie, it's no answer, it's an end."
            ]),
            l([
                "As a storm develops, I look for refuge,",
                "somewhere to shelter, out of the deluge."
            ]),
            l([
                "Exhaustion my companion, my reality, my pain.",
                "Finally, the turmoil begins to wane."
            ]),
            l([
                "Another storm passed, some time to recover.",
                "But still on this ocean, one day after another."
            ]),
            l([
                "An ocean now calm, too often full of anger,",
                "Seeking escape, seeking safety, seeking help, seeking an anchor."
            ])
        ])),
        A4(kt, "Motivational Words", "motivational-words", 20240611, l([
            l([
                "Sitting in this room,",
                "looking at these cards,",
                "don't know what to write.",
                "Why is this so hard?"
            ]),
            l([
                "Motivational words",
                "and open questions.",
                "They don't really resonate",
                "or inspire, these suggestions."
            ]),
            l([
                "I must be tired,",
                "I just need more rest.",
                "But why does this happen?",
                "Oh! Because I'm depressed!"
            ])
        ])),
        A4(kt, "Thought Control", "thought-control", 20240613, l([
            l([
                "Supposed to be working, but unable to focus.",
                "Thoughts so scattered, a chaotic locus.",
                "We're in control; you can't choke us!",
                "These thoughts seem to say, but I know that's bogus."
            ]),
            l([
                "Perhaps I should sit and meditate.",
                "It used to help, but not of late.",
                "So instead, I spiral, degenerate.",
                "The thoughts persist, perpetuate."
            ]),
            l([
                "Distractions help, the thoughts subside,",
                "But that then leaves me feeling guilty inside.",
                "Guilt that builds to finally collide",
                "With the old familiar anxiety, that inexorable tide."
            ]),
            l([
                "The thoughts might be gone, but now I'm left",
                "Broken, sundered, fragmented, cleft.",
                "Nothing remains, a victim of theft,",
                "Feeling drained, exhausted, utterly bereft."
            ])
        ])),
        A4(kt, "Father's Day", "fathers-day", 20240616, l([
            l([
                "The day that you died was, naturally,",
                "filled with sadness and grief.",
                "But among these emotions was another,",
                "an unexpected feeling of relief."
            ]),
            l([
                "In many ways, you were gone already,",
                "dementia slowly taking you away.",
                "But you weren't gone, you were suffering,",
                "until that fateful day."
            ]),
            l([
                "Towards the end, I couldn't visit,",
                "it brought me too much pain",
                "and in you, it only brought confusion,",
                "so I never visited again."
            ]),
            l([
                "Today, I reminisce old times,",
                "my memories of the past.",
                "The things we did together,",
                "The occasions when we laughed."
            ]),
            l([
                "I don't miss your jokes or deeds",
                "or the things that you provided.",
                "I miss, simply, your presence,",
                "and the love that once resided."
            ])
        ])),
        A4(kt, "Journey", "journey", 20240723, l([
            l([
                "Not so very many years ago",
                "I was unaware of what grew beneath",
                "the surface of my awareness.",
                "Depression was sinking in its teeth."
            ]),
            l([
                "Struggling through each day,",
                "a blur of chronic pain,",
                "medication numbed my senses,",
                "as this condition altered my brain."
            ]),
            l([
                "Eventually, the pain subsided,",
                "lessened by time and knowledge.",
                "The drugs were no longer necessary;",
                "without them, I could now manage."
            ]),
            l([
                "I enjoyed this restoration,",
                "and a brightness returned within.",
                "Alas, I soon realised,",
                "it was dimmer than it once had been."
            ]),
            l([
                "But it wasn't the passage of a decade",
                "that shadows my mind like a cloud.",
                "Something worse was suffocating,",
                "smothering me with its shroud."
            ]),
            l([
                "First, it brought anxiety,",
                "gripping with a sickening dread.",
                "No escape and no explanation,",
                "it was coming from my own head."
            ]),
            l([
                "With acceptance and familiarity",
                "I took away its power.",
                "It still simmers in the background",
                "Every minute, every hour."
            ]),
            l([
                "But opening this inner dialogue,",
                "plunging depths I didn't know existed,",
                "I encountered a hidden monster",
                "a part of me, dark and twisted."
            ]),
            l([
                "Surging to the surface,",
                "these thoughts I'd never had,",
                "feelings of utter despair,",
                "overwhelming and intolerably sad."
            ]),
            l([
                "I'm glad I opened this fissure",
                "to this chasm hiding below.",
                "I'm glad I learned it was there",
                "before it swallowed me whole."
            ]),
            l([
                "Striving and working to understand,",
                "to accept, to learn, to grow.",
                "I'm continuing on this journey",
                "and will see where next it may go."
            ])
        ])),
        A4(kt, "Dear Tony", "dear-tony", 20240730, l([
            l([
                "Dear Tony, I'm writing this letter to you today,",
                "in the hopes that it helps you to find your way."
            ]),
            l([
                "I can see that you're struggling with troubles and strife.",
                "Perhaps this will help you find some light in your life."
            ]),
            l([
                "Dark times will happen, from time to time.",
                "It can be challenging, waiting for the sun to shine."
            ]),
            l([
                "Try to remember that it's not going to last.",
                "Things always improve, like they have in the past."
            ]),
            l([
                "These ebbs and flows, these swings of the pendulum,",
                "they're a cycle, a rhythm, and you know you can ride them."
            ]),
            l([
                "You've done it before; you can do it again,",
                "and each time you do, it takes less and less strain."
            ]),
            l([
                "So hang in there Tony, you're doing ok.",
                "You've got this, you're getting stronger, each and every day."
            ])
        ])),
        A4(kt, "Seed", "seed", 20240814, l([
            l([
                "Today, I'm looking to see some light,",
                "at the end of the tunnel, that is my plight."
            ]),
            l([
                "I hold back the darkness with a candle flame,",
                "a hobby or interest, a temporary refrain."
            ]),
            l([
                "These candles don't last. The flames, they flutter.",
                "As one goes out, I light up another."
            ]),
            l([
                "The candlelight is weak, and this darkness so vast.",
                "They are all I have, and I'm determined to last."
            ]),
            l([
                "Inside me, I feel a light within.",
                "A seed of brightness that will never grow dim."
            ]),
            l([
                "This fragile seed, too small to withstand,",
                "the darkness around me, too much to demand."
            ]),
            l([
                "For now, these candles help me proceed,",
                "while I protect and nurture this beautiful seed."
            ]),
            l([
                "I carry it with me in the hope that, one day,",
                "it will grow to finally drive the darkness away."
            ])
        ])),
        A4(kt, "Counting", "counting", 20240907, l([
            l([
                "Counting the seconds",
                "where emotions reside;",
                "There, they can beckon,",
                "like a strong rip tide."
            ]),
            l([
                "Counting the minutes",
                "where thoughts may dwell,",
                "some fleeting snippets,",
                "others, hard to quell."
            ]),
            l([
                "Counting the hours",
                "where work gets done.",
                "Flourishing like flowers",
                "or wilting in the sun."
            ]),
            l([
                "Counting the days,",
                "wary of inaction.",
                "Looking for ways",
                "to find satisfaction."
            ]),
            l([
                "Counting the weeks",
                "as we rush around.",
                "Some pass in streaks,",
                "others run aground."
            ]),
            l([
                "Counting the months,",
                "seeking fulfilment.",
                "Challenges confront,",
                "and we hold with commitment."
            ]),
            l([
                "Counting the years,",
                "and the wisdom they bring,",
                "from blood, sweat and tears,",
                "and a refusal to give in."
            ]),
            l([
                "Counting the decades,",
                "reminiscing lost youth.",
                "Memory fades;",
                "We can't fight the truth."
            ]),
            l([
                "Counting my blessings,",
                "I'm still here today.",
                "Sometimes, with no bearings,",
                "but I'm still finding my way."
            ])
        ])),
        A4(kt, "Calm", "calm", 20241015, l([
            l([
                "The calm before the storm;",
                "a familiar feeling.",
                "Learning to recognise",
                "when my mood starts reeling."
            ]),
            l([
                "The calm in the eye",
                "of the storm as it flails.",
                "Holding myself tall,",
                "resisting the gales."
            ]),
            l([
                "The calm afterwards;",
                "a sense of relief.",
                "Time to rest and recover,",
                "however brief."
            ])
        ])),
        A4(kt, "Colours", "colours", 20241024, l([
            l([
                "Blue is the mood",
                "that I'm constantly hiding.",
                "Cover it with smiles",
                "and pretend that I'm thriving."
            ]),
            l([
                "Black is the knot",
                "of anxiety in my core.",
                "Tearing me apart,",
                "always wanting more."
            ]),
            l([
                "Red is the anger",
                "and frustration with myself,",
                "with this situation,",
                "with my poor mental health."
            ]),
            l([
                "Yellow is the compassion",
                "I try to find",
                "for myself as I struggle",
                "inside my mind."
            ]),
            l([
                "Green is the peace",
                "and tranquillity I feel",
                "on rare occasions,",
                "so full of appeal."
            ]),
            l([
                "White is the strength,",
                "the life, the vitality,",
                "that I see in others,",
                "but in me, lacks opacity."
            ])
        ])),
        A4(kt, "Sands of time", "sands-of-time", 20241029, l([
            l([
                "The sands of time keep falling;",
                "a whirlpool in slow motion.",
                "The reservoir slowly empties;",
                "a steady and inevitable erosion."
            ]),
            l([
                "Through the centre, they each fall;",
                "the grains become isolated.",
                "Their brief moment in the light,",
                "their glory illuminated."
            ]),
            l([
                "Delicately, they tumble down,",
                "landing amongst each other.",
                "Layer upon layer of memories;",
                "a tapestry of light and colour."
            ])
        ])),
        A4(kt, "Contradictions", "contradictions", 20241103, l([
            l([
                "Never really alone;",
                "friends and family all around.",
                "Never really alone,",
                "yet loneliness abounds."
            ]),
            l([
                "The world is full of colour;",
                "beautiful sights to delight.",
                "The world is full of colour;",
                "only seen in black and white."
            ]),
            l([
                "A symphony of sound;",
                "an orchestra of life in action.",
                "A symphony of sound;",
                "a constantly buzzing distraction."
            ]),
            l([
                "The universe is full of energy,",
                "a wonder to behold.",
                "The universe is full of energy,",
                "but still, I feel so cold."
            ])
        ])),
        A4(kt, "Pause", "pause", 20241115, l([
            l([
                "Make time, take time, to pause, to breathe,",
                "a time to take stock, a short reprieve,",
                "a moment of awareness, immersed in the presence,",
                "to fully connect with peace and quiescence."
            ])
        ])),
        A4(kt, "Beginnings", "beginnings", 20241210, l([
            l([
                "Beginning to see the light at the end of this tunnel.",
                "Stepping out of this darkness, away from this struggle."
            ]),
            l([
                "Beginning to see the edge of this dark forest.",
                "A way out of these trees full of torment and menace."
            ]),
            l([
                "Beginning to reach the end of this storm.",
                "Blue sky ahead, a gentle breeze so warm."
            ]),
            l([
                "Any of these beginnings would be a welcome relief.",
                "But thinking about them only makes me frustrated and angry."
            ])
        ])),
        A4(kt, "Fractured", "fractured", 20250129, l([
            l([
                "Fractured, scattered,",
                "incoherent thoughts,",
                "a storm in my head."
            ]),
            l([
                "Physically numb,",
                "emotionless except,",
                "anxiety and dread."
            ]),
            l([
                "Apathetic, lethargic,",
                "living seems pointless,",
                "but afraid to be dead."
            ])
        ])),
        A4(kt, "Alone", "alone", 20250130, l([
            l([
                "In the woods by myself, or at home, or with friends;",
                "always alone, in my thoughts, without end."
            ]),
            l([
                "Repeated attempts to engage with connections,",
                "feels like nothing more than feeble distractions."
            ]),
            l([
                "But alone with these thoughts, I try to remind",
                "myself that this is just my state of mind."
            ])
        ])),
        A4(kt, "Existential Thoughts", "existential-thoughts", 20250316, l([
            l([
                "Nihilistic thoughts keep plaguing my mind;",
                "constantly swirling, combined and aligned;",
                "wearing me down, this incessant grind.",
                "I wish I could leave these thoughts behind."
            ]),
            l([
                "People around me, all living, all dying.",
                "The universe doesn't care, so why are we trying",
                "to find a purpose, a sense of thriving?",
                "But to me, it's a fallacy, a delusion of lying."
            ]),
            l([
                "Why are we here? What is it all for?",
                "I can't see the point of anything any more.",
                "A sense of futility deep in my core.",
                "A battle in my mind, an eternal war."
            ]),
            l([
                "I look back at the path that brought me here,",
                "full of anger, anxiety, depression and fear.",
                "But with self-realisation and understanding, it's clear;",
                "I'll keep striving and finding a way to persevere."
            ]),
            l([
                "The path in front of me is blocked by a door,",
                "this one more massive than the one before.",
                "Through it, another revelation to explore.",
                "Another facet to add to my personal lore."
            ]),
            l([
                "Uncharted territory remains a constant attraction;",
                "a desire to grow, a call to action.",
                "Whatever I find, I must not abandon,",
                "so these existential thoughts are my new companion."
            ])
        ])),
        A4(kt, "Brighton Beach", "brighton-beach", 20250319, l([
            l([
                "Waves slowly rolling in one by one,",
                "rippling scintillations sparkling in the sun.",
                "Gently crashing with a whispering roar",
                "as excited pebbles dance along the shore."
            ])
        ])),
        A4(kt, "Abyss", "abyss", 20250410, l([
            l([
                "So tired, so drained, floating over the abyss.",
                "Feel nothing but pain that I can't dismiss.",
                "Trying to change, but keep returning to this.",
                "So tired, so drained, how can I resist?"
            ]),
            l([
                "So here, I float, suspended in the air.",
                "Below me, the abyss, and into it I stare.",
                "Nothing I can do, no way to prepare.",
                "Yet still I feel nothing but dread and despair."
            ]),
            l([
                "Here I am, stuck, in suspended animation.",
                "A repeating loop of observation and stagnation.",
                "No anticipation, no destination, no celebration of transformation.",
                "Just a voice, a narration of a futile situation."
            ])
        ])),
        A4(kt, "Shifting Sands", "shifting-sands", 20250626, l([
            l([
                "Waves at the beach, like events in our lives.",
                "Some soft and gentle, others violent like knives.",
                "Some may drench us in peace and serenity,",
                "while others tear at us with apparent enmity."
            ]),
            l([
                "Fair weather days, revelry so grand.",
                "Children play in the waves and build with the sand.",
                "Knowing their creations will get washed away,",
                "it matters not; they'll be made anew, on some other day."
            ]),
            l([
                "Fearful of storms, from a merciless sea,",
                "that pound at the sand and leave behind debris.",
                "But just as the sand moves and persists,",
                "so too do we, as our lives turn and twist."
            ]),
            l([
                "The tide comes in, and we fear we may drown;",
                "Overwhelmed by the sea as it weighs us down.",
                "But there's peace to be found when submerged below;",
                "a stillness, a serenity, if we can find the flow."
            ]),
            l([
                "The tide goes out and leaves us bare,",
                "exposing our souls to the open air.",
                "These moments are a good time to reflect.",
                "Bask in the sunlight while we introspect."
            ]),
            l([
                "One after another, these cycles continue.",
                "So, embrace the changes, and find balance within you."
            ])
        ])),
        A4(kt, "Kintsugi", "kintsugi", 20260114, l([
            l([
                "Pressure is slowly rising",
                "Cracks are starting to appear",
                "Stomach suddenly drops",
                "Overwhelming dread and fear."
            ]),
            l([
                "This is how it started",
                "Emotions buried inside",
                "Finally filled to bursting",
                "Nowhere left to hide."
            ]),
            l([
                "Gather up the pieces",
                "Clean them gentle as a feather",
                "See their enduring beauty",
                "and glue them back together."
            ]),
            l([
                "Fill the gaps with empathy",
                "Like gold mixed into the glue",
                "Experience becomes perspective",
                "Now wiser and better than new."
            ])
        ]))
    ]), Tt = yt(f), At = F2(function(e, n) {
        return n.b ? A3(Un, Ge, n, e) : e;
    }), jt = F2(function(e, n) {
        return A3(Un, At, f, A2(Xn, e, n));
    }), xt = F5(function(e, n, t, r, a) {
        return {
            v: r,
            x: t,
            u: n,
            q: a,
            z: e
        };
    }), St = function(e) {
        return e.b && ("" !== e.a || e.b.b) ? A2(Ge, e.a, St(e.b)) : f;
    }, Bt = F2(function(e, n) {
        return rn(1 === n.$ ? l([
            e
        ]) : A2(Ge, e, n.a));
    }), Nt = function(e) {
        try {
            return rn(decodeURIComponent(e));
        } catch (e) {
            return an;
        }
    }, Ct = i, _t = F2(function(e, n) {
        e: for(;;){
            if (-2 === n.$) return an;
            var t = n.c, r = n.d, a = n.e;
            switch(A2(Ct, e, n.b)){
                case 0:
                    n = r;
                    continue e;
                case 1:
                    return rn(t);
                default:
                    n = a;
                    continue e;
            }
        }
    }), Et = F5(function(e, n, t, r, a) {
        return {
            $: -1,
            a: e,
            b: n,
            c: t,
            d: r,
            e: a
        };
    }), Ft = {
        $: -2
    }, Lt = F5(function(e, n, t, r, a) {
        if (-1 !== a.$ || a.a) {
            if (-1 !== r.$ || r.a || -1 !== r.d.$ || r.d.a) return A5(Et, e, n, t, r, a);
            var i = r.d;
            return o = r.e, A5(Et, 0, r.b, r.c, A5(Et, 1, i.b, i.c, i.d, i.e), A5(Et, 1, n, t, o, a));
        }
        var o, u = a.b, s = a.c, f = a.d, c = a.e;
        return -1 !== r.$ || r.a ? A5(Et, e, u, s, A5(Et, 0, n, t, r, f), c) : A5(Et, 0, n, t, A5(Et, 1, r.b, r.c, r.d, o = r.e), A5(Et, 1, u, s, f, c));
    }), qt = F3(function(e, n, t) {
        if (-2 === t.$) return A5(Et, 0, e, n, Ft, Ft);
        var r = t.a, a = t.b, i = t.c, o = t.d, u = t.e;
        switch(A2(Ct, e, a)){
            case 0:
                return A5(Lt, r, a, i, A3(qt, e, n, o), u);
            case 1:
                return A5(Et, r, a, n, o, u);
            default:
                return A5(Lt, r, a, i, o, A3(qt, e, n, u));
        }
    }), Ot = F3(function(e, n, t) {
        var r = A3(qt, e, n, t);
        return -1 !== r.$ || r.a ? r : A5(Et, 1, r.b, r.c, r.d, r.e);
    }), Pt = function(e) {
        if (-1 === e.$ && -1 === e.d.$ && -1 === e.e.$) {
            if (-1 !== e.e.d.$ || e.e.d.a) {
                var n = e.d, t = e.e;
                return o = t.b, u = t.c, r = t.d, c = t.e, A5(Et, 1, e.b, e.c, A5(Et, 0, n.b, n.c, n.d, n.e), A5(Et, 0, o, u, r, c));
            }
            var r, a = e.d, i = e.e, o = i.b, u = i.c, s = (r = i.d).d, f = r.e, c = i.e;
            return A5(Et, 0, r.b, r.c, A5(Et, 1, e.b, e.c, A5(Et, 0, a.b, a.c, a.d, a.e), s), A5(Et, 1, o, u, f, c));
        }
        return e;
    }, Wt = function(e) {
        if (-1 === e.$ && -1 === e.d.$ && -1 === e.e.$) {
            if (-1 !== e.d.d.$ || e.d.d.a) {
                var n = e.d, t = e.e;
                return f = t.b, c = t.c, h = t.d, l = t.e, A5(Et, 1, r = e.b, a = e.c, A5(Et, 0, n.b, n.c, n.d, u = n.e), A5(Et, 0, f, c, h, l));
            }
            var r = e.b, a = e.c, i = e.d, o = i.d, u = i.e, s = e.e, f = s.b, c = s.c, h = s.d, l = s.e;
            return A5(Et, 0, i.b, i.c, A5(Et, 1, o.b, o.c, o.d, o.e), A5(Et, 1, r, a, u, A5(Et, 0, f, c, h, l)));
        }
        return e;
    }, zt = F7(function(e, n, t, r, a, i, o) {
        if (-1 !== i.$ || i.a) {
            e: for(;;){
                if (-1 === o.$ && 1 === o.a) {
                    if (-1 === o.d.$) {
                        if (1 === o.d.a) return Wt(n);
                        break e;
                    }
                    return Wt(n);
                }
                break e;
            }
            return n;
        }
        return A5(Et, t, i.b, i.c, i.d, A5(Et, 0, r, a, i.e, o));
    }), Dt = function(e) {
        if (-1 === e.$ && -1 === e.d.$) {
            var n = e.a, t = e.b, r = e.c, a = e.d, i = a.d, o = e.e;
            if (1 === a.a) {
                if (-1 !== i.$ || i.a) {
                    var u = Pt(e);
                    if (-1 === u.$) {
                        var s = u.e;
                        return A5(Lt, u.a, u.b, u.c, Dt(u.d), s);
                    }
                    return Ft;
                }
                return A5(Et, n, t, r, Dt(a), o);
            }
            return A5(Et, n, t, r, Dt(a), o);
        }
        return Ft;
    }, Jt = F2(function(e, n) {
        if (-2 === n.$) return Ft;
        var t = n.a, r = n.b, i = n.c, o = n.d, u = n.e;
        if (0 > a(e, r)) {
            if (-1 === o.$ && 1 === o.a) {
                var s = o.d;
                if (-1 !== s.$ || s.a) {
                    var f = Pt(n);
                    if (-1 === f.$) {
                        var c = f.e;
                        return A5(Lt, f.a, f.b, f.c, A2(Jt, e, f.d), c);
                    }
                    return Ft;
                }
                return A5(Et, t, r, i, A2(Jt, e, o), u);
            }
            return A5(Et, t, r, i, A2(Jt, e, o), u);
        }
        return A2(Mt, e, A7(zt, e, n, t, r, i, o, u));
    }), Mt = F2(function(e, n) {
        if (-1 === n.$) {
            var r = n.a, a = n.b, i = n.c, o = n.d, u = n.e;
            if (t(e, a)) {
                var s = function(e) {
                    for(;;){
                        if (-1 !== e.$ || -1 !== e.d.$) return e;
                        e = e.d;
                    }
                }(u);
                return -1 === s.$ ? A5(Lt, r, s.b, s.c, o, Dt(u)) : Ft;
            }
            return A5(Lt, r, a, i, o, A2(Jt, e, u));
        }
        return Ft;
    }), Rt = F2(function(e, n) {
        var t = A2(Jt, e, n);
        return -1 !== t.$ || t.a ? t : A5(Et, 1, t.b, t.c, t.d, t.e);
    }), Kt = F3(function(e, n, t) {
        var r = n(A2(_t, e, t));
        return r.$ ? A2(Rt, e, t) : A3(Ot, e, r.a, t);
    }), Yt = F2(function(e, n) {
        var t = A2(un, "=", e);
        if (t.b && t.b.b && !t.b.b.b) {
            var r = t.b.a, a = Nt(t.a);
            if (1 === a.$) return n;
            var i = a.a, o = Nt(r);
            return 1 === o.$ ? n : A3(Kt, i, Bt(o.a), n);
        }
        return n;
    }), Ht = Ft, Gt = F2(function(e, n) {
        var t;
        return function(e) {
            e: for(;;){
                if (e.b) {
                    var n = e.a, t = n.u;
                    if (t.b) {
                        if ("" !== t.a || t.b.b) {
                            e = e.b;
                            continue e;
                        }
                        return rn(n.q);
                    }
                    return rn(n.q);
                }
                return an;
            }
        }(e(A5(xt, f, function(e) {
            var n = A2(un, "/", e);
            return St(n.b && "" === n.a ? n.b : n);
        }(n.aj), 1 === (t = n.aq).$ ? Ht : A3(Un, Yt, Ht, A2(un, "&", t.a)), n.aa, Cn)));
    }), Ut = A2(F2(function(e, n) {
        return function(e) {
            var t = e.z, r = e.u, a = e.x, i = e.v, o = e.q;
            if (r.b) {
                var u = r.a, s = r.b, c = n(u);
                if (c.$) return f;
                var h = c.a;
                return l([
                    A5(xt, A2(Ge, u, t), s, a, i, o(h))
                ]);
            }
            return f;
        };
    }), "POEM_URL", rn), Xt = re("resetTitleAndDescription", function() {
        return null;
    }), Zt = F2(function(e, n) {
        return A5(xt, n.z, n.u, n.x, n.v, e(n.q));
    }), Qt = F2(function(e, n) {
        var t = n;
        return function(n) {
            var r = n.z, a = n.u, i = n.x, o = n.v;
            return A2(Xn, Zt(n.q), t(A5(xt, r, a, i, o, e)));
        };
    }), Vt = F2(function(e, n) {
        return A2(Qt, n, e);
    }), er = function(e) {
        return e;
    }, nr = re("setDescription", er), tr = re("setTitle", er), rr = function(e) {
        return l([
            e
        ]);
    }, ar = F2(function(e, n) {
        var r, a = (r = l([
            A2(Vt, rr, o(u(n, {
                w: ht
            }), Xt(0))),
            A2(Vt, Ut, function(e) {
                var r, a, i = (r = e, (a = A2($t, function(e) {
                    return t(e.aZ, r);
                }, It)).b ? rn(a.a) : an);
                if (i.$) return o(u(n, {
                    w: ht
                }), Tt);
                var s, f = i.a;
                return o(u(n, {
                    w: (s = f, {
                        $: 1,
                        a: s
                    })
                }), yt(l([
                    tr(f.J + " - " + wt(f.K)),
                    nr("A poem by Tony Hunt")
                ])));
            })
        ]), function(e) {
            return A2(jt, function(n) {
                return n(e);
            }, r);
        }), i = A2(Gt, a, e);
        return i.$ ? o(u(n, {
            w: ht
        }), Tt) : i.a;
    }), ir = F2(function(e, n) {
        var t;
        return e.$ ? A2(ar, e.a, n) : o(n, e.a.$ ? (t = e.a.a, A2(ct, Kn, P(function() {
            try {
                Me.location = t;
            } catch (e) {
                ue.location.reload(!1);
            }
        }))) : A2(lt, n.L, gt(e.a.a)));
    }), or = ce("a"), ur = F2(function(e, n) {
        return A2(le, e, er(n));
    }), sr = ur("className"), fr = ce("footer"), cr = ce("span"), hr = fe, lr = A2(fr, f, l([
        A2(cr, f, l([
            hr("\xa9 2025 Tony Hunt, all rights reserved")
        ]))
    ])), dr = ce("h1"), vr = ce("header"), gr = function(e) {
        var n;
        return A2(ur, "href", ve.test(n = e) ? "" : n);
    }, br = ce("li"), mr = d, yr = ce("ul"), pr = (tt = function(e) {
        return A2(br, l([
            sr("poem-entry")
        ]), l([
            A2(or, l([
                gr(e.aZ)
            ]), l([
                A2(cr, l([
                    sr("poem-entry-title")
                ]), l([
                    hr(e.J)
                ])),
                A2(cr, l([
                    sr("poem-entry-date")
                ]), l([
                    hr(wt(e.K))
                ]))
            ]))
        ]));
    }, l([
        A2(vr, f, l([
            A2(dr, f, l([
                hr("Poems by Tony Hunt")
            ]))
        ])),
        A2(yr, l([
            sr("poems-list")
        ]), A2(Xn, tt, A2(mr, function(e) {
            return e.K;
        }, It))),
        lr
    ])), wr = ce("article"), $r = ce("h2"), kr = $, Ir = ce("p"), Tr = F2(function(e, n) {
        return n.$ ? e : n.a;
    }), Ar = function(e) {
        var n, t = function(e) {
            var n, t;
            return A2(Tr, o(" ", ""), (t = (n = e).charCodeAt(0), isNaN(t) ? an : rn(55296 > t || t > 56319 ? o(n[0], n.slice(1)) : o(n[0] + n[1], n.slice(2)))));
        }(e), r = t.a, a = t.b;
        return A2(Ir, l([
            sr("line")
        ]), l([
            A2(cr, l([
                sr("first-letter")
            ]), l([
                hr((n = r, A2(kr, n, "")))
            ])),
            hr(a)
        ]));
    }, jr = ce("section"), xr = function(e) {
        return A2(jr, l([
            sr("stanza")
        ]), A2(Xn, Ar, e));
    };
    rt = {
        Main: {
            init: (at = {
                aP: bt,
                aS: function(e) {
                    return {
                        $: 1,
                        a: e
                    };
                },
                aT: function(e) {
                    return {
                        $: 0,
                        a: e
                    };
                },
                aX: Re(mt),
                aY: ir,
                a_: function(e) {
                    var n, t;
                    return {
                        aH: (t = e.w, t.$ ? (n = t.a, l([
                            A2(vr, f, l([
                                A2(or, l([
                                    gr("/")
                                ]), l([
                                    hr("Back to list")
                                ])),
                                A2(dr, f, l([
                                    hr(n.J)
                                ])),
                                A2($r, f, l([
                                    hr(wt(n.K))
                                ]))
                            ])),
                            A2(wr, l([
                                sr("poem")
                            ]), A2(Xn, xr, n.aW)),
                            lr
                        ])) : pr),
                        J: "Poems by Tony Hunt"
                    };
                }
            }, it = at.aS, ot = at.aT, ut = function() {
                ut.a(it(De()));
            }, We({
                P: function(e) {
                    return ut.a = e, Me.addEventListener("popstate", ut), 0 > Me.navigator.userAgent.indexOf("Trident") || Me.addEventListener("hashchange", ut), F2(function(n, t) {
                        if (!(t.ctrlKey || t.metaKey || t.shiftKey || t.button >= 1 || n.target || n.hasAttribute("download"))) {
                            t.preventDefault();
                            var r = n.href, a = De(), i = Rn(r).a;
                            e(ot(i && a.ap === i.ap && a.ad === i.ad && a.al.a === i.al.a ? {
                                $: 0,
                                a: i
                            } : function(e) {
                                return {
                                    $: 1,
                                    a: e
                                };
                            }(r)));
                        }
                    });
                },
                aP: function(e) {
                    return A3(at.aP, e, De(), ut);
                },
                a_: at.a_,
                aY: at.aY,
                aX: at.aX
            }))((st = 0, {
                $: 0,
                a: st
            }))(0)
        }
    }, e.Elm ? function e(n, t) {
        for(var r in t)r in n ? "init" == r ? b(6) : e(n[r], t[r]) : n[r] = t[r];
    }(e.Elm, rt) : e.Elm = rt;
}($a0b4f895e1596b3b$exports);


var $dad545c909cfec2d$var$app = (0, $a0b4f895e1596b3b$exports.Elm).Main.init({
    node: document.querySelector('main')
});
$dad545c909cfec2d$var$app.ports.setTitle.subscribe(function(title) {
    document.title = title;
    document.head.querySelector('meta[property="og:title"]').setAttribute('content', title);
});
$dad545c909cfec2d$var$app.ports.setDescription.subscribe(function(description) {
    document.head.querySelector('meta[name="description"]').setAttribute('content', description);
    document.head.querySelector('meta[property="og:description"]').setAttribute('content', description);
});
$dad545c909cfec2d$var$app.ports.resetTitleAndDescription.subscribe(function() {
    document.title = 'Poems by Tony Hunt';
    document.head.querySelector('meta[property="og:title"]').setAttribute('content', 'Poems by Tony Hunt');
    document.head.querySelector('meta[name="description"]').setAttribute('content', 'A collection of poems by Tony Hunt');
    document.head.querySelector('meta[property="og:description"]').setAttribute('content', 'A collection of poems by Tony Hunt');
});


//# sourceMappingURL=repo.6b21892d.js.map
